// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2S16u","delete":"styles_delete__3So41","update":"styles_update__2ZFlN","add":"styles_add__1RCQS"};